import React, { useEffect, useMemo, useState } from 'react';

import { FlexView } from '@cuemath/comps';
import ReactTable from 'react-table';
import styled from 'styled-components';

import { useParentGet } from 'actions/parent-pii';
import Search from 'modules/list/search-bar';

import BallLoader from 'comps/ball-loader';
import {
  FetchErrorContainer,
  FilterWrapper,
  FullFlexView,
  LinkNav,
  TableWrapper,
} from '../utils/styled-components';

const AbsoluteLoaderContainer = styled(FlexView)`
  position: absolute;
  top: 200px;
  left: 40%;
`;

const tableColumns = [
  {
    Header: `Parent`,
    columns: [
      {
        Header: 'Name',
        accessor: 'name',
        width: 200,
        Cell: row => {
          return (
            <LinkNav
              target="_blank"
              to={{
                pathname: `/parent-pii/${row.original.id}`,
              }}
            >
              {row.original.name}
            </LinkNav>
          );
        },
      },
    ],
  },
];

const transformData = parents => {
  return parents.map(({ first_name, last_name, id }) => ({
    name: `${first_name} ${last_name}`,
    id,
  }));
};

const ParentTab = () => {
  const [searchKey, setSearchKey] = useState('');

  const { get: getParent, data, isProcessing, isProcessingFailed } = useParentGet();

  useEffect(() => {
    if (searchKey) getParent(searchKey);
  }, [searchKey, getParent]);

  const tableData = useMemo(() => (data ? transformData([data]) : []), [data]);

  const onSearch = searchKey => {
    setSearchKey(searchKey);
  };

  return (
    <FullFlexView justifyContent="center" alignItems="center">
      <FilterWrapper>
        <Search onSearch={onSearch} placeholder="Search Parents..." />
      </FilterWrapper>
      {isProcessing && (
        <AbsoluteLoaderContainer>
          <BallLoader />
        </AbsoluteLoaderContainer>
      )}
      {isProcessingFailed && (
        <FetchErrorContainer>
          <p>Not able to fetch data.</p>
        </FetchErrorContainer>
      )}
      {tableData?.length > 0 && (
        <TableWrapper>
          <ReactTable
            data={tableData}
            manual
            showPageSizeOptions={false}
            filterable={false}
            sortable={false}
            resizable={false}
            defaultPageSize={20}
            columns={tableColumns}
            style={{ textAlign: 'center' }}
          />
        </TableWrapper>
      )}
    </FullFlexView>
  );
};

export default ParentTab;
